// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Jg0y","inputWrap":"CustomTip_inputWrap__2UUYN"};